

import { ref, computed, Ref } from 'vue-demi';
import { IssueAssembleResponse } from '../models/issue';
import { ActionStore } from './action';
import { ProjectStore } from './project';
import { without } from 'lodash';

const DEFAULT_EXPANDS = ['summary', 'description'];

const CODE_MAP: any = {
  'subtask': 'issueSubTaskVOList',
  'attachment': 'fileOuterVOList',
  'relationship': 'issueRelationshipVOList'
};

// 允许折叠为 label 的字段 fieldCode 或 controlCode（只有这些字段参与 label 折叠逻辑）
const LABEL_ELIGIBLE_FIELDS: string[] = ['summary', 'attachment', 'subtask', 'relationship', 'rich-text', 'docs'];

//字段不在布局展示时，使其功能存在，但是不展示（比如附件不展示得时候，需要用到附件的复制粘贴拖拽功能，使用v-show控制）
const EXIST_BUT_HIDE_CODES = ['attachment', 'subtask'];
// 忽略手动设置(比如附件，有值时才展示)
const IGNORE_MANUAL_SET_CODES = ['attachment'];

export const useLeftNavigationLabel = (
  actionStore: ActionStore,
  allRequiredFieldCodes: Ref<string[]>,
  leftAreaCodes: Ref<string[]>,
  issueAssemble: Ref<IssueAssembleResponse | null>,
  getFieldStore: () => any,
  projectStore: ProjectStore
) => {

  const awaitForProjectRoleCodes = computed(() => {
    return projectStore.projectRoleLoading.value ? ['attachment'] : [];
  });

  const manualExpandCodes = ref<string[]>(DEFAULT_EXPANDS);

  const hasValueCodes = computed(() => {
    const fieldStore = getFieldStore();
    return leftAreaCodes.value.filter((code: string) => {
      const fieldValue = CODE_MAP[code]
        ? (issueAssemble.value as any)?.[CODE_MAP[code]]?.length || (actionStore.action.value as any)?.defaultData?.[code]?.length
        : issueAssemble.value?.issueVO?.data?.[code] || (actionStore.action.value as any)?.defaultData?.[code]?.length;

      const value = fieldStore.fieldValues.value?.[code] || fieldValue;
      return Array.isArray(value) ? value.length > 0 : !!value;
    });
  });

  // 判断字段是否可以被折叠为 label（只有特定的大块字段才参与折叠）
  const isLabelEligible = (code: string) => {
    const fieldStore = getFieldStore();
    const field = fieldStore.fieldCodeMap.value?.[code];
    const controlCode = field?.controlCode;
    return LABEL_ELIGIBLE_FIELDS.includes(code) || LABEL_ELIGIBLE_FIELDS.includes(controlCode);
  };

  const leftAreaShowFieldCodes = computed(() => {
    console.log('---->.>', hasValueCodes.value);
    return leftAreaCodes.value.filter((code: string) => {
      // 非 label 可折叠字段始终展示
      if (!isLabelEligible(code)) {
        return true;
      }
      return allRequiredFieldCodes.value.includes(code) || hasValueCodes.value.includes(code) || manualExpandCodes.value.includes(code);
    });
  });

  const leftAreaShowLabelCodes = computed(() => {
    return leftAreaCodes.value.filter((code: string) => !leftAreaShowFieldCodes.value.includes(code));
  });

  const setManualExpandCode = (code: string) => {
    if (!manualExpandCodes.value.includes(code) && !IGNORE_MANUAL_SET_CODES.includes(code)) {
      manualExpandCodes.value = [...manualExpandCodes.value, code];
    }
  };

  const removeManualExpandCode = (code: string) => {
    if (!manualExpandCodes.value.includes(code)) {
      return;
    }
    manualExpandCodes.value = without(manualExpandCodes.value, code);
  };

  const reset = () => {
    manualExpandCodes.value = DEFAULT_EXPANDS;
  };

  return {
    manualExpandCodes,
    leftAreaShowFieldCodes,
    leftAreaShowLabelCodes,
    hasValueCodes,
    setManualExpandCode,
    removeManualExpandCode,
    awaitForProjectRoleCodes,
    existButHideCodes: computed(() => {
      return EXIST_BUT_HIDE_CODES.filter((code) => leftAreaCodes.value.includes(code) && !leftAreaShowFieldCodes.value.includes(code));
    }),
    reset
  };
};

export type LeftNavigationLabelStore = ReturnType<typeof useLeftNavigationLabel>;
